import { observer } from 'mobx-react-lite'

import { Margin } from 'components/ui'
import { Flex, Text } from 'components/uiKit'
import { colors } from 'shared/constants/values'

import backIcon from 'assets/img/lk-section/Order/order-statuses/back.png'
import exclaimIcon from 'assets/img/lk-section/Order/order-statuses/exclaim.png'
import failureIcon from 'assets/img/lk-section/Order/order-statuses/failure.png'
import successIcon from 'assets/img/lk-section/Order/order-statuses/success.png'
import waitIcon from 'assets/img/lk-section/Order/order-statuses/wait.png'
import s from './OrderItemStatusHeader.module.scss'

export type OrderStatusType = 'success' | 'wait' | 'back' | 'exclaim' | 'failure'

const typeToIng: { [key in OrderStatusType]: string } = {
  success: successIcon,
  wait: waitIcon,
  back: backIcon,
  failure: failureIcon,
  exclaim: exclaimIcon,
}

type OrderItemStatusHeaderProps = {
  type: 'success' | 'wait' | 'back' | 'exclaim' | 'failure'
  title: string
  isActive?: boolean
  subTitle?: string
}

export const OrderItemStatusHeader = observer(
  ({ title, type, isActive = false, subTitle }: OrderItemStatusHeaderProps) => {
    return (
      <Flex
        className={s.OrderItemStatusHeader}
        style={{ backgroundColor: isActive ? colors.grayLight : 'transparent' }}
        align="center"
        gap={16}
      >
        <Flex className={s.iconWrapper} justify="center" align="center">
          <img className={s.icon} style={{ width: type === 'exclaim' ? 4 : 24 }} src={typeToIng[type]} />
        </Flex>

        <Margin ml={16}>
          <Flex vertical>
            <Text className={s.text} style={{ color: isActive ? colors.corp : colors.secondary }} strong>
              {title}
            </Text>
            <Text className={s.text} style={{ color: isActive ? colors.corp : colors.secondary }} strong>
              {subTitle}
            </Text>
          </Flex>
        </Margin>
      </Flex>
    )
  },
)
